import type { CertificationPreview } from "@brookbush/types";

import { useAuth } from "@clerk/nextjs";
import posthog from "posthog-js";
import toast from "react-hot-toast";
import { mutate as globalMutate } from "swr";
import useSWRImmutable from "swr/immutable";

import fetcher from "~/utils/fetcher.client";

const useSelectedCertification = () => {
	const { isSignedIn, isLoaded } = useAuth();

	const {
		data: selectedCertification,
		mutate,
		...rest
	} = useSWRImmutable<CertificationPreview | null>(
		isSignedIn && `/certifications/selected`,
	);

	const handleSelectCertification = async (
		certification: CertificationPreview | null,
	) => {
		await toast.promise(
			mutate(
				fetcher(`/certifications/selected`, {
					data: {
						certificationId: certification?._id || null,
					},
					method: "PUT",

					headers: {
						"x-posthog-session-id": posthog.get_session_id(),
					},
				}),
				{
					optimisticData: certification,
				},
			),
			{
				error: "Error saving...",
				loading: "Processing",
				success: "Changes Saved",
			},
		);

		globalMutate("/courses/in-progress");
		globalMutate("/onboarding/checklist");
	};

	return {
		selectedCertification,
		handleSelectCertification,
		isLoadingSelectedCertification: rest.isLoading || !isLoaded,
		...rest,
	};
};

export default useSelectedCertification;
